module.exports = __webpack_public_path__ + "img/img12.6f2d6b96.png";